<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }
  /* 隐藏滚动条但仍可滚动 */
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
  
  a{text-decoration:none}
  .display_center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .display_start{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .display_end{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .display_space{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .one_line{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .two_line{
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
  }
  .three_line{
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:3;
    -webkit-box-orient:vertical;
  }
  .pointer{
    cursor:pointer;
  }
  .contents{
    width: 100%;
  }
  .content{
    width: 1200px;
  }
  img{
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contract;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue